import { get } from 'lodash';

export const PMO = 'ROLE_PMO';
export const ATR = 'ROLE_ATR';
export const FACILITY_MANAGER = 'ROLE_FACILITY_MANAGER';
export const FACILITY_OPERATOR = 'ROLE_FACILITY_OPERATOR';
export const ATTENDANT = 'ROLE_ATTENDANT';
export const HOST = 'ROLE_HOST';
export const COOPERATOR = 'ROLE_COOPERATOR';
export const USGS_ROLE = 'ROLE_USGS';
export const FINANCE_ADMIN = 'ROLE_FINANCE_ADMIN';
export const FINANCE_USER = 'ROLE_FINANCE_USER';
export const CSR = 'ROLE_CSR';
export const SUPER_USER = 'ROLE_SUPER_USER';
export const SYSTEM_USER = 'ROLE_SYSTEM_USER';
export const BAH_FINANCE = 'ROLE_BAH_FINANCE';
export const PASS_OPERATOR = 'ROLE_PASS_OPERATOR';

export const roleTypeToDisplayMap = {
  ROLE_PMO: 'PMO',
  ROLE_ATR: 'APM',
  ROLE_FACILITY_MANAGER: 'Facility Management',
  ROLE_FACILITY_OPERATOR: 'Facility Operations',
  ROLE_ATTENDANT: 'Attendant',
  ROLE_HOST: 'Host',
  ROLE_COOPERATOR: 'Cooperator',
  ROLE_USGS: 'USGS',
  ROLE_FINANCE_ADMIN: 'Finance Admin',
  ROLE_FINANCE_USER: 'Finance User',
  ROLE_CSR: 'Customer Service Representative',
  ROLE_SUPER_USER: 'Super User',
  ROLE_BAH_FINANCE: 'Booz Allen Finance',
  ROLE_PASS_OPERATOR: 'Pass Operations'
};

export function getReadableRole(programmaticRole) {
    return get(roleTypeToDisplayMap, programmaticRole, '');
}

export function getRoleAtLocation(user, locationID) {
    let role = '';
    user.roles.forEach((item) => {
        // If we find a role for this location or R1S root; use that role
        if (item.location.location_id === locationID || item.location.location_id === "1") {
            role = item.role_type;
        }
    })

    return role;
}